import React, { useEffect, useState } from 'react';
import { v4_fetch_mailbox_recipients } from '../../actions/v4/mailBox';
import { mapRecipientOptions } from './recipientSelectUtils';


const AddReipient = ({ onAddRecipient, onDeleteRecipient }) => {
    const [state, setState] = useState({
        name: { name: 'name', value: '', error: '', isRequired: true },
        email: { name: 'email', value: '', error: '', isRequired: true },
    });
    const [savedRecipients, setSavedRecipients] = useState([]);
    const [loadingRecipients, setLoadingRecipients] = useState(false);
    const [deletingRecipientId, setDeletingRecipientId] = useState(null);

    const loadRecipients = async () => {
        setLoadingRecipients(true);
        try {
            const res = await v4_fetch_mailbox_recipients();
            if (res.status) {
                const options = mapRecipientOptions(res.result)
                    .filter((recipient) => recipient.canDelete && recipient.id);
                setSavedRecipients(options);
            }
        } catch (err) {
            console.error('Failed to fetch recipients:', err);
        } finally {
            setLoadingRecipients(false);
        }
    };

    useEffect(() => {
        loadRecipients();

        const handleRecipientsChanged = () => loadRecipients();
        window.addEventListener('mailboxRecipientsChanged', handleRecipientsChanged);

        return () => window.removeEventListener('mailboxRecipientsChanged', handleRecipientsChanged);
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState((prev) => ({
            ...prev,
            [name]: { ...prev[name], value, error: '' },
        }));
    };

    const validateForm = () => {
        let valid = true;
        const newState = { ...state };

        Object.keys(newState).forEach((key) => {
            if (newState[key].isRequired && !newState[key].value?.length) {
                newState[key].error = 'This field is required';
                valid = false;
            } else {
                newState[key].error = '';
            }
        });

        setState(newState);
        return valid;
    };



    const handleSend = async () => {
        if (!validateForm()) return;

        const payload = {
            name: state.name.value,
            email: state.email.value,
        };

        try {
            const success = await onAddRecipient(payload);
            if (success) {
                setState({
                    name: { name: 'name', value: '', error: '', isRequired: true },
                    email: { name: 'email', value: '', error: '', isRequired: true },
                });
                loadRecipients();
            }
        } catch (err) {
            console.error('Send mail error:', err);
            alert('Failed to add recipient.');
        }
    };

    const handleDelete = async (recipient) => {
        if (!recipient?.id || !onDeleteRecipient) return;
        const confirmed = window.confirm(`Delete ${recipient.label}?`);
        if (!confirmed) return;

        setDeletingRecipientId(recipient.id);
        try {
            const success = await onDeleteRecipient(recipient.id);
            if (success) {
                setSavedRecipients((prev) => prev.filter((item) => item.id !== recipient.id));
            }
        } finally {
            setDeletingRecipientId(null);
        }
    };

    return (
        <React.Fragment>
            <div className="modal-body">
                <div className="mb-3">
                    <input
                        name="name"
                        value={state.name.value}
                        onChange={handleChange}
                        className="form-control"
                        placeholder='Name'
                    />
                    {state.name.error && <small className="text-danger">{state.name.error}</small>}
                </div>

                <div className="mb-3">
                    <input
                        type="text"
                        className="form-control"
                        name="email"
                        value={state.email.value}
                        onChange={handleChange}
                        placeholder="Email"
                    />
                    {state.email.error && <small className="text-danger">{state.email.error}</small>}
                </div>

                <div className="border-top pt-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="mb-0">Saved Recipients</h6>
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary"
                            onClick={loadRecipients}
                            disabled={loadingRecipients}
                            title="Refresh recipients"
                        >
                            <i className="mdi mdi-refresh" />
                        </button>
                    </div>

                    {loadingRecipients ? (
                        <p className="text-muted mb-0">Loading recipients...</p>
                    ) : savedRecipients.length === 0 ? (
                        <p className="text-muted mb-0">No saved recipients.</p>
                    ) : (
                        <div className="list-group" style={{ maxHeight: '260px', overflowY: 'auto' }}>
                            {savedRecipients.map((recipient) => (
                                <div
                                    key={recipient.id}
                                    className="list-group-item d-flex justify-content-between align-items-center gap-2"
                                >
                                    <span className="text-truncate" title={recipient.label}>
                                        {recipient.label}
                                    </span>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-danger"
                                        onClick={() => handleDelete(recipient)}
                                        disabled={deletingRecipientId === recipient.id}
                                        title="Delete recipient"
                                    >
                                        <i className="mdi mdi-delete-outline" />
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            <div className="modal-footer">
                <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                >
                    Close
                </button>
                <button type="button" className="btn text-white" style={{ backgroundColor: '#2b5a7e' }} onClick={handleSend}>
                    Add
                </button>
            </div>
        </React.Fragment>
    );
};

export default AddReipient;
